import { useContext } from 'react'
import { Helmet } from 'react-helmet-async'
import { useLocation } from 'react-router-dom'

import { faFile } from '@fortawesome/pro-light-svg-icons'

import {
  Box, Button, Columns,
} from '@domain-group/suit-theme'

import PageContext from '@contexts/pageContext'

import useAgencySelector from '@hooks/useAgencySelector'
import useAssetLibrary, { generateUrls } from '@hooks/useAssetLibrary'

import NotificationBannerLocation from '@components/NotificationBannerLocation'
import NotificationModuleLocation from '@components/NotificationModuleLocation'
import PageFilterModule from '@components/PageFilterModule'
import PageHeader from '@components/PageHeader'

import AgencyAssetLibraries from '../AgencyAssetLibraries'
import BrandAssetLibraries from '../BrandAssetLibraries'

const buildPageFilterFields = () => [
  {
    component: 'DynamicInput',
    componentProps: {
      inputComponent: 'input',
      style: { marginBottom: 16 },
    },
    key: 'string',
    label: 'Filter by Title',
  },
]

interface PageContentProps {
  pageFilters: {
    [key: string]: any,
  },
}

const PageContent = (props: PageContentProps) => {
  const { pageFilters } = props

  useLocation()

  const { selectedAgencyId } = useAgencySelector()

  const pageContext = useContext(PageContext)
  const {
    callbacks: {
      resetFilters,
      updateFilters,
    },
    defaultFilters,
  } = pageContext

  const initAssetLibrary = { owner_id: selectedAgencyId, owner_type: 'Agency' }

  const useAssetLibraryPayload = useAssetLibrary(initAssetLibrary)

  const {
    callbacks: { createOrEditAssetLibrary },
  } = useAssetLibraryPayload

  const urls = generateUrls(initAssetLibrary, { prefixRoute: `agencies/${selectedAgencyId}/manage` })
  const { assetLibrariesIndexUrl } = urls

  return (
    <>
      <Helmet>
        <title>Asset Libraries | Realhub</title>
      </Helmet>

      <PageHeader
        actionContent={(
          <Button
            buttonStyle="primaryCreate"
            onClick={() => createOrEditAssetLibrary()}
            size="medium"
          >
            Create
          </Button>
        )}
        activeTabBarItemKey="assetLibraries"
        nestedNavigation
        tabBarItems={[
          {
            href: assetLibrariesIndexUrl,
            icon: faFile,
            key: 'assetLibraries',
            title: 'Document Library',
          },
        ]}
        title="Document Library"
      />

      <Box paddingX="large" paddingTop={[112, 105]}>
        <Columns boxProps={{ marginTop: 'large' }} flexDirection={['column', 'column', 'row']}>
          <Columns.Main>
            <NotificationBannerLocation locationKey="agency.agencyManager.assetLibraries.banner" />

            <AgencyAssetLibraries pageFilters={pageFilters} />

            <BrandAssetLibraries pageFilters={pageFilters} />
          </Columns.Main>

          <Columns.Sidebar>
            <NotificationModuleLocation locationKey="agency.agencyManager.assetLibraries.sidebar" />

            <PageFilterModule
              callbacks={{ resetFilters, updateFilters }}
              defaultFilters={defaultFilters}
              // @ts-expect-error TS2322
              filterFields={buildPageFilterFields()}
              pageFilters={pageFilters}
              title="Filters"
            />
          </Columns.Sidebar>
        </Columns>
      </Box>
    </>
  )
}

export default PageContent
